import cuid from "cuid";
import { useMobileView } from 'hook/mobileView/useMobileView';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Class } from 'services/api/class';
import { LeftSide } from './LeftSide';
import { RightSide } from './RightSide';
import { Body } from './Theme';

const ClassInfo = () => {
    const { isMobile } = useMobileView()
    const { classDetails } = useSelector((state) => state?.Class)
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(Class.actions.setCounterTicket([cuid()]));
        localStorage.setItem("registrationForm", JSON.stringify([]))
        localStorage.setItem("ApplayCheckBox", JSON.stringify(false))
    }, [])

    return (
        <Body>
            {Object.keys(classDetails || {}).length !== 0 &&
                <>
                    {!isMobile && <LeftSide
                        background={classDetails?.background}
                        description={classDetails?.description}
                    />}
                    <RightSide />
                </>}

        </Body>
    );
};

export default ClassInfo;